import {
  advanceHintEscalation,
  type ActiveHintStage,
  type HintEscalationState
} from "./hint-escalation";

export interface SuccessFeedback {
  readonly kind: "success";
  readonly tone: "affirming";
  readonly nextAction: "continue";
}

export interface RetryFeedback {
  readonly kind: "retry";
  readonly tone: "neutral";
  readonly nextAction: "try-again";
  readonly hintStage: ActiveHintStage;
}

export type ActivityFeedback = SuccessFeedback | RetryFeedback;

export interface RetryFeedbackTransition {
  readonly hintState: HintEscalationState;
  readonly feedback: RetryFeedback;
}

export function createSuccessFeedback(): SuccessFeedback {
  return {
    kind: "success",
    tone: "affirming",
    nextAction: "continue"
  };
}

export function createRetryFeedback(
  currentHintState: HintEscalationState
): RetryFeedbackTransition {
  const hintState = advanceHintEscalation(currentHintState);

  return {
    hintState,
    feedback: {
      kind: "retry",
      tone: "neutral",
      nextAction: "try-again",
      hintStage: hintState.stage
    }
  };
}
